// extracted by mini-css-extract-plugin
export default {"form_control":"ButtonAuthGitHub_form_control__V67sP","form_control__login":"ButtonAuthGitHub_form_control__login__HQHZh"};